import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import sortableGroup from 'ember-sortable/modifiers/sortable-group';
import sortableItem from 'ember-sortable/modifiers/sortable-item';
import BvInline from 'volta/components/bv-inline';
import BvDndHandle from 'volta/components/bv-dnd/handle';
import BvTag from 'volta/components/bv-tag';
import BvCheckbox from 'volta/components/bv-checkbox';
import BvRadio from 'volta/components/bv-radio';
import and from 'ember-truth-helpers/helpers/and';
import not from 'ember-truth-helpers/helpers/not';
import notEq from 'ember-truth-helpers/helpers/not-eq';
import or from 'ember-truth-helpers/helpers/or';
import { fn } from '@ember/helper';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import type { ICollectionGroupOption } from 'volta/models/types/collection-view';
export interface CollectionViewGroupsSignature {
    Args: {
        options: ICollectionGroupOption[];
        groupLimit?: number;
        groupMin?: number;
        disabled?: boolean;
        onChange?: (groupBy: string[]) => void;
        onReorder?: (groupBy: string[]) => void;
    };
    Element: HTMLDivElement;
}
export default class CollectionViewGroupsComponent extends Component<CollectionViewGroupsSignature> {
    resourceName = {
        singular: 'attribute',
        plural: 'attributes'
    };
    groupName = `CollectionViewGroups_${guidFor(this)}`;
    handleSortEndAction = (sortOptions: string[])=>{
        this.args.onReorder?.([
            ...(sortOptions ?? [])
        ]);
    };
    get isGroupMin() {
        if (!this.args.groupMin) {
            return false;
        }
        return this.args.options.filter((option)=>option.selected).length <= this.args.groupMin;
    }
    static{
        template_fd9b2463e5f141cfb5666b64daa1f11a(`
    <div
      class='collection-view-groups'
      {{sortableGroup groupName=this.groupName onChange=this.handleSortEndAction direction='y'}}
      ...attributes
    >
      {{#each @options key='value' as |option|}}
        {{#let
          (or (not option.selected) (not option.editable) @disabled)
          (component BvTag text=option.label color=option.color size='sm')
          as |dndDisabled label|
        }}
          <BvInline
            class='u-py-1 u-px-1 u-bg-surface'
            @blockAlign='center'
            @wrap={{false}}
            @gap='1'
            {{sortableItem groupName=this.groupName model=option disabled=dndDisabled}}
          >
            <BvDndHandle @disabled={{dndDisabled}} />
            {{#if (notEq @groupLimit 1)}}
              <BvCheckbox
                @label={{label}}
                @checked={{option.selected}}
                @disabled={{or
                  @disabled
                  (not option.editable)
                  (and option.selected this.isGroupMin)
                }}
                @onChange={{fn (optional @onChange) option}}
                @labelClass='u-overflow-hidden'
                class='u-overflow-hidden'
              />
            {{else}}
              <BvRadio
                @label={{label}}
                @checked={{option.selected}}
                @disabled={{or @disabled (not option.editable)}}
                @onChange={{fn (optional @onChange) option}}
                @labelClass='u-overflow-hidden'
                class='u-overflow-hidden'
              />
            {{/if}}
          </BvInline>
        {{/let}}
      {{/each}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'CollectionView::Groups': typeof CollectionViewGroupsComponent;
        'collection-view/groups': typeof CollectionViewGroupsComponent;
    }
}
